import _ from 'lodash';

function initialState () {
  return {
    token: null,
    userid: null,
    user: null,
    profile: null,
    userApps: []
  }
}

const state = initialState()

const actions = {
  loadUserID: function (context, userid) {
    context.commit('loadUserID', userid);
    // var URL = 'users/' + state.userid + '/'
    // axios.get(URL).then((response) => {
    //   context.commit('loadUser', response.data)
    // })
  },
  removeUserID: function ({ commit }) {
    commit('removeUserID')
  },
  loadUser (context, u) {
    context.commit('loadUser', u)
  },
  updateUser: function (context, u) {
    context.commit('updateUser', u)
  },
  loadProfile: function (context, p) {
    context.commit('loadProfile', p)
  },
  updateProfile: function (context, p) {
    context.commit('updateProfile', p)
  },
  loadUserApps: function (context, apps) {
    context.commit('loadUserApps', apps)
  },
  loadToken: function (context, tok) {
    // var tok = localStorage.getItem('token')
    if (tok === null) {
      tok = localStorage.getItem('token')
    }
    context.commit('loadToken', tok)
  },
  removeToken: function ({ commit }) {
    commit('removeToken')
  },
  resetAuth: function ({ commit }) {
    commit('resetAuth')
  }
}

const mutations = {
  resetAuth (state) {
    // acquire initial state
    const s = initialState()
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },
  loadToken (state, tok) {
    state.token = tok
  },
  removeToken (state) {
    state.token = null
  },
  loadUserID (state, userid) {
    state.userid = userid
  },
  loadProfile (state, userProfile) {
    state.profile = userProfile
  },
  removeUserID (state) {
    state.userid = null
  },
  updateUser (state, u) {
    state.user = u
  },
  updateProfile (state, p) {
    state.profile = p
  },
  loadUser (state, user) {
    state.user = user
  },
  loadUserApps (state, apps) {
    state.userApps = _.sortBy(apps, 'app_obj.dashboard_order')
  }
}

export default {
  state,
  actions,
  mutations
}
